// extracted by mini-css-extract-plugin
export default {"wrap":"TJ-z","articleImagesWrap":"UJ-z","articleImage":"VJ-z","singleImage":"WJ-z"};